export default __webpack_public_path__ + "static/media/pokemon_normal.c9722703.png";